import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { useViewingLead } from "@/contexts/ViewingLeadContext";
import { useLocation } from "wouter";


const EXCLUDED_PATHS = [
  "/membership",
  "/booking",
  "/first-session",
  "/quiet-private-gym",
  "/see-the-gym",
  "/january",
  "/private-access-basepoint",
  "/open-day",
];

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const { openModal } = useViewingLead();
  const [location] = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isExcluded = EXCLUDED_PATHS.some(path => location.startsWith(path));

  if (isExcluded) return null;

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0 pointer-events-none"
      }`}
    >
      <Button
        onClick={() => openModal("Floating CTA")}
        className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg rounded-full px-6 py-6 text-base font-medium"
        data-testid="button-floating-cta"
      >
        <Calendar className="w-5 h-5 mr-2" />
        See the gym first
      </Button>
    </div>
  );
}
